/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

// @ts-ignore
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontSize: '0.875rem',
                    lineHeight: 1.43,
                    letterSpacing: '0.01071em',
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&.Mui-selected, &.Mui-selected:hover': {
                        backgroundColor: '#EEEFEF',
                    },
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        backgroundColor: '#EBEBEB',
                    },
                    '&.Mui-selected:focus, &.Mui-selected:hover': {
                        backgroundColor: '#EBEBEB',
                    },
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    paddingLeft: 24,
                    paddingRight: 24,
                    paddingTop: 8,
                    paddingBottom: 8,
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                sizeSmall: {
                    padding: '3px',
                },
            },
        },
    },
    palette: {
        primary: {
            light: '#BDDCDE',
            main: '#2C8B92',
            dark: '#006666',
            contrastText: '#FFFFFF',
        },
        secondary: {
            light: '#40434A',
            main: '#2B2F36',
            contrastText: '#FFFFFF',
        },
        error: {
            light: '#FBE6E1',
            main: '#FF8367',
            dark: '#DB6348',
            contrastText: '#FFFFFF',
        },
        warning: {
            light: '#FCF2CE',
            main: '#F8D767',
            dark: '#FFBC00',
            contrastText: '#FFFFFF',
        },
        info: {
            light: '#A7D1D3',
            main: '#2C8B92',
            dark: '#006666',
            contrastText: '#FFFFFF',
        },
        text: {
            primary: '#4B493E',
            secondary: '#7A786F',
        },
        action: {
            disabledBackground: '#92C2C5',
            disabled: '#FFFFFF',
        },
        mainBackground: {
            light: '#F3F3F3',
            main: '#E5E5E5',
            dark: '#7178B9',
        },
        altText: {
            main: '#FFFFFF',
        },
        asanImza: {
            main: '#8E24AA',
        },
        disabledText: {
            main: '#A8A8A4',
            light: '#E0E0E0',
        },
        link: {
            main: '#2C8B92',
        },
        scrollBar: {
            light: '#F1F1F1',
            main: '#C1C1C1',
            dark: '#BDDCDE',
        },
        brown: {
            light: '#F2E4E0',
            main: '#D9AFA6',
            dark: '#BF7A6A',
            contrastText: '#FFFFFF',
        },
        lightCoral: {
            light: '#EBDBD9',
            main: '#F6C3B6',
            dark: '#F3AC99',
            contrastText: '#FFFFFF',
        },
        coral: {
            light: '#F7A298',
            main: '#FE846F',
            dark: '#C17A63',
            contrastText: '#FFFFFF',
        },
        green: {
            light: '#80CBC3',
            main: '#439788',
        },
        teal: {
            light: '#A7D1D3',
            main: '#2C8B92',
            dark: '#006666',
            contrastText: '#FFFFFF',
        },
        lightTeal: {
            main: '#E0F2F1',
        },
        blueTeal: {
            light: '#7BACB2',
            main: '#728989',
            dark: '#466B71',
            contrastText: '#FFFFFF',
        },
        lightAmber: {
            light: '#FDEFCF',
            main: '#FFE7B5',
            dark: '#DDBF72',
            contrastText: '#4B493E',
        },
        amber: {
            light: '#FFD56B',
            main: '#FFBC00',
            dark: '#D19615',
            contrastText: '#4B493E',
        },
        amberBackground: {
            light: '#FEFBF0',
            main: '#FEFAEB',
            dark: '#FDF3D1',
        },
    },
});
